import { StreamStatus } from 'constants/statuses';
import { TStreamStatus } from 'types';

export const streamIsNotProcessing = (status: TStreamStatus) => {
  if (status === StreamStatus.Stopping || status === StreamStatus.Launching) return false;

  return true;
};
